import { Exception } from "./Exception";
import { ErrorSeverity } from "./ErrorSeverity";

export class UnauthorizedException extends Exception {
  constructor({ message, response, stack }: { message: string; response: Response; stack?: string }) {
    super({
      errorSeverity: ErrorSeverity.ERROR,
      useErrorBoundary: false,
      name: "UnauthorizedErrorException",
      message,
      response,
      stack,
    });
  }
}
